var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-component"},[_c('a',{attrs:{"href":_vm.href}},[_c('img',{staticClass:"social-img",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"src":_vm.src,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }